<template>
  <div>
    <!--头部-->
    <HeaderForBeauty :showValue="1"></HeaderForBeauty>
    <!--banner end-->
    <div class="jqgk" style="background:rgba(227, 227, 227, 0.84)">
      <div class="contai" style="max-width:1197px;;padding-left:20px;padding-right:20px">
        <div class="top_tit" style="margin-top:30px">
          <div style="height:50px;width:100%;text-align:left;line-height:50px">
            <div class="beautytab">
              <div class="table-item" v-for="item in listCaiDan" :key="item.id">
                <span
                  :style="select == item.id ? styletable : mapStyle"
                  class="table-button"
                  @click="selectJJ(item.id)"
                  >{{ item.title }}</span
                >
              </div>
            </div>
          </div>
          <div style="height:1px;width:100%"></div>
          <div style="text-align:left;background-color:#fff">
            <!-- 图片显示 -->
            <el-row style="margin:30px 60px 20px 60px;padding-top:0px;">
              <p v-if="pcshow" class="zjll">
                最佳浏览时间：{{ timeshow }}
              </p>

              <p v-if="!pcshow" class="zjllForPhone">
                最佳浏览时间：{{ timeshow }}
              </p>
              <!-- PC端 -->
              <div v-if="pcshow" style="display: flex; flex-direction: row; flex-wrap : wrap ;">
                <a-spin :spinning="spinning" :delay="delayTime" >
                <div style="display: flex; flex-flow: row wrap;">
                <div v-for="item in dataList" :key="item.key" :style="item.showType == 2 ? 'width:50%': item.showType == 3 ? 'width:33.33%':'width:100%' ">
                  <div  v-if="item.showType == 3" >
                    <div class="showPicture" style="margin:0 0 20px 0;">
                      <img  v-for="(item2,index) in [item]" :key="index" :src="item.url" :preview="index"  class="sceneryImgSizeForLS"/>
                      <div class="sceneryFontSizeForLS">{{ item.title }}</div>
                      <span class="sceneryDescFontSizeForEntime">观赏地：{{ item.area }}</span>
                      <span class="sceneryDescFontSizeForEntime">观赏时间：{{ item.areaTime }}</span>
                    </div>
                  </div>

                  <div  v-if="item.showType == 2" >
                    <div class="showPicture" style="margin:0 0 20px 0;">
                      <img  v-for="(item2,index) in [item]" :key="index" :src="item.url" :preview="index" class="sceneryImgSizeForLS"/>
                      <div class="sceneryFontSizeForLS">{{ item.title }}</div>
                      <span class="sceneryDescFontSizeForNew" >{{ item.introduce }}</span>
                      <span class="sceneryDescFontSizeForEntime">观赏时间：{{ item.areaTime }}</span>
                    </div>
                  </div>

                  <div  v-if="item.showType == 1" >
                  <!-- <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"> -->
                    <div class="showPicture" style="margin:0 0 20px 0;">
                      <img :src="item.url" alt="...." class="sceneryImgSizeForLS" />
                      <div class="sceneryFontSizeForLS">{{ item.title }}</div>
                      <span  class="sceneryDescFontSizeForNew">{{ item.introduce }}</span
                      >
                      <!-- style="max-height:90px" -->
                      <!-- <span class="sceneryDescFontSizeForEntime"
                        >观赏地：{{ item.area }}</span
                      > -->
                      <span class="sceneryDescFontSizeForEntime">观赏时间：{{ item.areaTime }}</span>
                    </div>
                  <!-- </el-col> -->
                  </div>
                  </div>
                </div>
                </a-spin>
              </div>
            </el-row>
            <!--  手机端 -->
            <div v-if="!pcshow" class="">
              <div v-for="item in dataList" :key="item.key">
                <img :src="item.url" alt="...." style="width:100%;display:flex;flex-direction:column;justify-content:flex-start" />
                <div class="sceneryFontSize">{{ item.title }}</div>
                <div v-show="item.introduce" class="mobileSceneryDescFontSizeB">{{
                  item.introduce
                }}</div>
                <div class="sceneryFontSizeForM" style="font-size:14px"
                  >观赏地：{{ item.area }}</div
                >
                <div class="sceneryFontSize" style="font-size:14px"
                  >观赏时间：{{ item.areaTime }}</div
                >
                <!-- <div style="text-align:right">
                  <button class="mobileSceneryBtn" @click="seeInfo(item)">
                    更多
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import { getBeautyFor } from '@/api/public'
import HeaderForBeauty from './headerforbeauty'
import Footer from './footer'
export default {
  components: { HeaderForBeauty, Footer },
  data () {
    return {
      listCaiDan: [],
      select: 1,
      chooseValue: 1,
      pcshow: false,
      styletable: {},
      mapStyle: {
        color: '#840207',
        background:
          'linear-gradient(270deg, rgba(132, 2, 7, 0.29), rgba(132, 2, 7, 0))'
      },
      spinning: true,
      delayTime: 500,
      dataList: [],
      timeshow: '春天',
      listCaiDan: [
        { title: '春天', id: 1 },
        { title: '夏天', id: 2 },
        { title: '秋天', id: 3 },
        { title: '冬天', id: 4 }
      ]
    }
  },
  beforeCreate () {},
  created () {
    if (this._isMobile()) {
      this.pcshow = false
    } else {
      this.pcshow = true
    }
  },

  mounted () {
    this.init1()
  },

  methods: {
    openview () {
      // alert('789')
    },
    selectJJ (num) {
      if (num == 1) {
        this.select = 1
        this.timeshow = '春天'
        this.init1()
      }
      if (num == 2) {
        this.select = 2
        this.timeshow = '夏天'
        this.init1()
      }
      if (num == 3) {
        this.select = 3
        this.timeshow = '秋天'
        this.init1()
      }
      if (num == 4) {
        this.select = 4
        this.timeshow = '冬天'
        this.init1()
      }
    },
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    init1 () {
      getBeautyFor(this.timeshow).then(response => {
        this.spinning = true
        var list = response.data
        this.dataList = list.sort(this.compare('sort'))
        this.dataList.forEach((item, index, arr) => {
          this.dataList[index].introduce == undefined || this.dataList[index].introduce == ' ' || this.dataList[index].introduce == undefined || this.dataList[index].introduce == '' ? this.dataList[index].introduce = false : ''
        })
        console.log('this.dataList:', this.dataList)
        this.spinning = false
      })
    },
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    // 详情()
    seeInfo (infoid) {
      this.$router.push({
        path: '/sceneryInfo',
        query: {
          id: infoid
        }
      })
    }
  }
}
</script>
<style>
.zjllForPhone{
  font-size:15px;
  margin-bottom:10px;
  color:#840207;
  padding: 20px 0 0 0px;
}
.zjll{
  font-size:15px;
  margin-bottom:10px;
  color:#840207;
  padding: 20px 0;
}
.sceneryImgSizeForLS {
  padding-right: 20px;
  height: 380px;
  width: 500px;
}
.sceneryDescFontSizeForNew {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0px 20px 0 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.sceneryDescFontSizeForEntime {
  padding: 0px 20px 0 0;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 550;
  color: #484848;
  line-height: 30px;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mobileSceneryDescFontSizeForEntime {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 600;
  color: #484848;
  line-height: 30px;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.titleShuXian {
  height: 48px;
  margin-top: 9px;
  width: 8px;
  background-color: #840207;
  float: left;
}
.titleFontForLSEnglish {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 10px;
  padding-bottom: 15px;
}
.tra_tab {
  font-size: 28px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  width: 193px;
  height: 67px;
  text-align: center;
  line-height: 67px;
  cursor: pointer;
}
.tra_tab_mobile {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  padding: 10px;
}
.tra_tab_line_mobile {
  display: block;
  width: 100%;
  height: 2px;
  background: #840207;
  opacity: 0.1;
}
.tra_tab_line {
  display: block;
  width: 100%;
  height: 8px;
  background: #840207;
  opacity: 0.1;
}
.titleFontForLS {
  font-size: 16px;
  font-family: Microsoft YaHei;
  color: #840207;
  line-height: 36px;
  float: left;
  padding: 15px 15px 0 0;
}

.sceneryFontSizeForLS {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  width: 270px;
  /* height: 40px; */
  line-height: 40px;
  padding: 0px;
}
.showPicture {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  align-items: stretch;
}

.sceneryBtn {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #ffffff;
  width: 126px;
  height: 44px;
  background: #840207;
  border: none;
  margin: 25px 0px 50px;
}
.sceneryFontSize {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  /* width: 270px; */
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}
.sceneryFontSizeForM{
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  /* width: 270px; */
  height: 40px;
  line-height: 40px;
  padding: 0px 20px;
  /* margin-left: -25px; */
  text-align: left;
}
.mobileSceneryDescFontSizeB {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0 20px;
  /* max-height: 60px; */
  /* display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden; */
}
.mobileSceneryBtn {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #ffffff;
  width: 126px;
  height: 44px;
  background: #840207;
  border: none;
  margin-right: 10px;
  margin-bottom: 5px;
}
.beautytab {
  white-space: nowrap;
  height: 5rem;
  line-height: 1.466666666666667rem;
  font-size: 0.7rem;
  overflow-y: hidden;
  padding-top: 10px;
}
.beautytab .table-item {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: inline-block;
}
.beautytab .table-button {
  min-width: 61px;
  height: 30px;
  border-radius: 4px;
  background: #840207;
  border-radius: 4px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #fff5e0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BeautyAllOver.vue